import { EventTemplate } from "nostr-tools";
import { nip44 } from "nostr-tools";

export interface NwcCredentials {
  uri: string; // nostr+walletconnect://... URI
}

const NWC_D_TAG = "litstrudel/nwc-wallet";
const NWC_KIND = 30078;

/**
 * Encrypt NWC credentials as a kind 30078 replaceable event.
 * Uses NIP-44 encryption to self (conversation key = own secret key + own pubkey).
 */
export function createNwcCredentialEvent(
  credentials: NwcCredentials,
  conversationKey: Uint8Array,
): EventTemplate {
  const plaintext = JSON.stringify(credentials);
  const encrypted = nip44.v2.encrypt(plaintext, conversationKey);
  return {
    kind: NWC_KIND,
    created_at: Math.floor(Date.now() / 1000),
    content: encrypted,
    tags: [["d", NWC_D_TAG]],
  };
}

/**
 * Decrypt NWC credentials from a kind 30078 event.
 */
export function decryptNwcCredentials(
  encryptedContent: string,
  conversationKey: Uint8Array,
): NwcCredentials {
  const plaintext = nip44.v2.decrypt(encryptedContent, conversationKey);
  return JSON.parse(plaintext);
}

export { NWC_D_TAG, NWC_KIND };
